import * as CONST from "../src/constants/urlConstants";

let domainSplitResult = window.location.hostname.split('.');
let kenobiDomain = domainSplitResult[0];
domainSplitResult[0] = '';
let subDomain = domainSplitResult.join('.');

let ssoPrefix = 'sso';
let portalPrefix = 'service';
let meteringPrefix = 'metering';
let consolePrefix = 'console';

switch (subDomain) {
  case CONST.DOOSAN:
    ssoPrefix = CONST.DOOSAN_SSO;
    portalPrefix = CONST.DOOSAN_PORTAL;
    meteringPrefix = CONST.DOOSAN_COST;
    consolePrefix = 'cloudmpconsole';
    break;
  case CONST.HYUNDAIMOVEX:
    ssoPrefix = CONST.HYUNDAIMOVEX_SSO;
    portalPrefix = CONST.HYUNDAIMOVEX_PORTAL;
    meteringPrefix = CONST.HYUNDAIMOVEX_COST;
    break;
  case CONST.NEW_SCK:
  case CONST.SCK:
    portalPrefix = CONST.SCK_PORTAL;
    meteringPrefix = CONST.SCK_COST;
    break;
  case CONST.WINS21:
    portalPrefix = CONST.WINS21_PORTAL;
    break;
  case CONST.MDSOPSNOW:
    meteringPrefix = CONST.MDSOPSNOW_COST;
    break;
  case CONST.COMTEC:
    portalPrefix = CONST.COMTEC_PORTAL;
    break;
  case CONST.HYUNDAI_AUTOEVER:
  case CONST.HYUNDAI_AUTOEVER_NEW:
    ssoPrefix = CONST.HYUNDAI_AUTOEVER_SSO;
    portalPrefix = CONST.HYUNDAI_AUTOEVER_PORTAL;
    meteringPrefix = CONST.HYUNDAI_AUTOEVER_COST;
    kenobiDomain = CONST.HYUNDAI_AUTOEVER_KENOBI;
    consolePrefix = 'console-cmp'
    break;
}

let ssoUrl = ''
let kenobiUrl = window.location.protocol + "//" + window.location.host
let portalUrl= ''
let meteringAdminUrl = ''
let meteringUrl = ''
let portalAdminUrl= ''
let supportUrl= ''
let srUrl = ''
let profile = ''
let brandUrl= ''
let opsnow360Url = ''
let consoleUrl= ''
let openapiUrl= ''

switch(process.env.ENV) {
  case 'prd':
    ssoUrl = "https://" + ssoPrefix + subDomain;
    kenobiUrl = window.location.protocol + "//" + window.location.host;
    portalUrl = "https://" + portalPrefix + subDomain
    meteringAdminUrl = "https://mtadmin" + subDomain;
    meteringUrl = "https://" + meteringPrefix + subDomain;
    portalAdminUrl =  "https://admin" + subDomain;
    supportUrl = "https://support.opsnow.com/customer/login"
    srUrl = "https://support.opsnow.com/customer/login"
    brandUrl = "https://www.opsnow.com";
    opsnow360Url = "";
    consoleUrl = "https://" + consolePrefix + subDomain;
    openapiUrl = "https://api.opsnow.com";
    break;
  case 'dev':
    ssoUrl = "https://" + ssoPrefix + subDomain;
    kenobiUrl = window.location.protocol + "//" + window.location.host;
    portalUrl = "https://" + portalPrefix + "dev" + subDomain;
    meteringAdminUrl = "https://mtadmindev" + subDomain;
    meteringUrl = "https://" + meteringPrefix + "dev" + subDomain;
    portalAdminUrl =  "https://admindev" + subDomain;
    supportUrl = "https://support.opsnow.com/customer/login"
    srUrl = "https://support.opsnow.com/customer/login"
    brandUrl = "https://servicedev.opsnow.com";
    opsnow360Url = "https://servicedev.opsnow.com/portal/";
    consoleUrl = "https://consoledev" + subDomain;
    openapiUrl = "https://apidev.opsnow.com";
    break;
  case 'gstg':
    ssoUrl = "https://" + ssoPrefix + subDomain;
    kenobiUrl = window.location.protocol + "//" + window.location.host;
    portalUrl = "https://" + portalPrefix + subDomain;
    meteringAdminUrl = "https://mtadmin" + subDomain;
    meteringUrl = "https://" + meteringPrefix + subDomain;
    portalAdminUrl =  "https://admin" + subDomain;
    supportUrl = "https://support.opsnow.com/customer/login"
    srUrl = "https://support.opsnow.com/customer/login"
    brandUrl = "https://www.opsnow.me";
    opsnow360Url = "https://service.gstg.opsnow.com/portal/";
    consoleUrl = "https://" + consolePrefix + subDomain;
    openapiUrl = "https://api.gstg.opsnow.com";
    break;
  case 'mea':
    ssoUrl = "https://" + ssoPrefix + subDomain;
    kenobiUrl = window.location.protocol + "//" + window.location.host;
    portalUrl = "https://" + portalPrefix + subDomain;
    meteringAdminUrl = "https://mtadmin" + subDomain;
    meteringUrl = "https://" + meteringPrefix + subDomain;
    portalAdminUrl =  "https://admin" + subDomain;
    supportUrl = "https://support.opsnow.com/customer/login"
    srUrl = "https://support.opsnow.com/customer/login"
    brandUrl = "https://www.opsnow.me";
    opsnow360Url = "https://service.opsnow.me/portal/";
    consoleUrl = "https://" + consolePrefix + subDomain;
    openapiUrl = "https://api.opsnow.me";
    break;
  case 'usa':
    ssoUrl = "https://" + ssoPrefix + subDomain;
    kenobiUrl = window.location.protocol + "//" + window.location.host;
    portalUrl = "https://" + portalPrefix + subDomain;
    meteringAdminUrl = "https://mtadmin" + subDomain;
    meteringUrl = "https://" + meteringPrefix + subDomain;
    portalAdminUrl =  "https://admin" + subDomain;
    supportUrl = "https://support.opsnow.com/customer/login"
    srUrl = "https://support.opsnow.com/customer/login"
    brandUrl = "https://www.opsnow.us";
    opsnow360Url = ""
    consoleUrl = "https://" + consolePrefix + subDomain;
    openapiUrl = "https://api.opsnow.us";
    break;
  case 'hcmp':
    ssoUrl = "https://" + ssoPrefix + subDomain;
    kenobiUrl = window.location.protocol + "//" + window.location.host;
    portalUrl = "https://" + portalPrefix + subDomain;
    meteringAdminUrl = "https://mtadmin" + subDomain;
    meteringUrl = "https://" + meteringPrefix + subDomain;
    portalAdminUrl =  "https://admin" + subDomain;
    supportUrl = "https://support.opsnow.com/customer/login"
    srUrl = "https://support.opsnow.com/customer/login"
    brandUrl = "https://api.cmp.honecloud.co.kr";
    opsnow360Url = ""
    consoleUrl = "https://" + consolePrefix + subDomain;
    openapiUrl = "";
    break;
  case 'kecmp':
    ssoUrl = "https://" + ssoPrefix + subDomain;
    kenobiUrl = window.location.protocol + "//" + window.location.host;
    portalUrl = "https://" + portalPrefix + subDomain;
    meteringAdminUrl = "https://mtadmin" + subDomain;
    meteringUrl = "https://" + meteringPrefix + subDomain;
    portalAdminUrl =  "https://admin" + subDomain;
    supportUrl = "https://support.opsnow.com/customer/login"
    srUrl = "https://support.opsnow.com/customer/login"
    brandUrl = "https://www.kakaocmp.com";
    opsnow360Url = ""
    consoleUrl = "https://" + consolePrefix + subDomain;
    openapiUrl = "https://api.kakaocmp.com";
    break;
}
export default {
  ssoUrl : ssoUrl,
  kenobiUrl : kenobiUrl,
  portalUrl : portalUrl,
  meteringAdminUrl : meteringAdminUrl,
  meteringUrl : meteringUrl,
  portalAdminUrl : portalAdminUrl,
  supportUrl : supportUrl,
  srUrl : srUrl,
  subDomain : subDomain,
  kenobiDomain: kenobiDomain,
  profile : profile,
  brandUrl : brandUrl,
  opsnow360Url : opsnow360Url,
  consoleUrl : consoleUrl,
  openapiUrl : openapiUrl,
}



//////////////////
// WEBPACK FOOTER
// ./config/urls.conf.js
// module id = null
// module chunks = 